import actionTypes from '../constants/action-types';
import constants from '../constants';

const KEY_PHRASE = Symbol('I_KNOW_THAT_I_AM_PERFORMING_A_DANGEROUS_OPERATION');

const mergeHistory = ({ stepCount, status = constants.STATUS_UNDO, keyPhrase }) => {
  /*
   * mergeHistory is a dangerous action, invalid usage can lead to invalid history behaviour
   * and data corruption.
   * */
  if (!keyPhrase || keyPhrase !== KEY_PHRASE) {
    throw new Error('You are not allowed to merge history');
  }

  return {
    type: actionTypes.MERGE_HISTORY,
    payload: {
      stepCount,
      status,
    },
  };
};

mergeHistory.I_KNOW_THAT_I_AM_PERFORMING_A_DANGEROUS_OPERATION = KEY_PHRASE;

export default mergeHistory;
